function normalizeText(value) {
  return typeof value === "string" ? value.trim() : "";
}

export function resolveSelectedDispatchDayActionState({
  allowEveningOrderPool = false,
  canRunOptimization = false,
  dispatchDayControls = null,
  dispatchInteractions = {},
  dispatchStatus = null,
  missingLatestOptimization = null,
  onOpenSnapshot = null,
  selectedDispatchDay = null,
} = {}) {
  const hasSelectedDispatchDate = Boolean(
    normalizeText(selectedDispatchDay?.dispatch_date ?? selectedDispatchDay?.dispatchDate),
  );
  const hasSnapshot = dispatchDayControls?.activeItem?.hasSnapshot === true
    || selectedDispatchDay?.has_snapshot === true
    || selectedDispatchDay?.hasSnapshot === true
    || Boolean(dispatchStatus?.lastOptimizedAt);
  const isSourceStale = missingLatestOptimization?.isSourceStale === true;
  const canOptimize = canRunOptimization === true && (dispatchStatus?.canOptimize === true
    || (allowEveningOrderPool && ["courant", "a_revalider"].includes(dispatchStatus?.key)));
  const isFrozen = dispatchStatus?.isFrozen === true;
  const requiresRevalidation = dispatchStatus?.requiresRevalidation === true || dispatchStatus?.key === "a_revalider";
  const activeDispatchState = normalizeText(dispatchDayControls?.activeDispatchState).toLowerCase();
  const hasDispatch = dispatchDayControls?.activeItem?.hasDispatch === true
    || selectedDispatchDay?.has_dispatch === true
    || selectedDispatchDay?.hasDispatch === true;
  const canCloseDispatchDay = dispatchInteractions.canCloseDispatchDay === true
    && hasSelectedDispatchDate
    && hasDispatch
    && activeDispatchState !== "closed";
  const canReopenDispatchDay = dispatchInteractions.canReopenDispatchDay === true
    && hasSelectedDispatchDate
    && activeDispatchState === "closed";
  const showOpenSnapshotAction = hasSelectedDispatchDate
    && hasSnapshot
    && typeof onOpenSnapshot === "function";
  const showOptimizeAction = canOptimize
    && !isFrozen
    && (!hasSnapshot || requiresRevalidation || isSourceStale);
  const showNoSnapshotHint = !hasSnapshot && canOptimize;

  return {
    canCloseDispatchDay,
    canOptimize,
    canReopenDispatchDay,
    hasSnapshot,
    isFrozen,
    isSourceStale,
    requiresRevalidation,
    showNoSnapshotHint,
    showOpenSnapshotAction,
    showOptimizeAction,
  };
}
